<script setup lang="ts">
import { onMounted, ref } from 'vue'
import { useRoute } from 'vue-router'
import AppHeader from '@/layouts/AppHeader/AppHeader.vue'
import UiFooter from '@/components/UiFooter/UiFooter.vue'

const route = useRoute()
const isLoading = ref(true)
const errorMessage = ref<string | null>(null)

const DC_SCRIPTS_PROD = [
  'https://dcapi.direct-credit.ru/JsHttpRequest.js',
  'https://dcapi.direct-credit.ru/dc.js'
]

const DC_STYLES_PROD = 'https://dcapi.direct-credit.ru/style.css'

const DC_SCRIPTS_DEV = [
  'https://test.direct-credit.ru/api/JsHttpRequest.js',
  'https://test.direct-credit.ru/api/testdc-test.js'
]

const DC_STYLES_DEV = 'https://test.direct-credit.ru/api/style.css'

const isDev = import.meta.env.VITE_DIRECT_CREDIT_ENV === 'dev'
const dcScripts = isDev ? DC_SCRIPTS_DEV : DC_SCRIPTS_PROD
const dcStyles = isDev ? DC_STYLES_DEV : DC_STYLES_PROD

function loadStyle(href: string): void {
  const link = document.createElement('link')
  link.rel = 'stylesheet'
  link.href = href
  document.head.appendChild(link)
}

function loadScript(src: string): Promise<void> {
  return new Promise((resolve, reject) => {
    const script = document.createElement('script')
    script.src = src
    script.charset = 'utf-8'
    script.onload = () => resolve()
    script.onerror = () => reject(new Error(`Не удалось загрузить скрипт: ${src}`))
    document.head.appendChild(script)
  })
}

onMounted(async () => {
  const token = route.query.token as string
  const partner = route.query.partner as string
  const successUrl = route.query.success_url as string
  const failUrl = route.query.fail_url as string

  if (!token || !partner) {
    errorMessage.value = 'Некорректная ссылка для оплаты'
    isLoading.value = false
    return
  }

  try {
    loadStyle(dcStyles)

    // Скрипты DCLoans загружаем последовательно — JsHttpRequest должен загрузиться первым
    for (const src of dcScripts) {
      await loadScript(src)
    }

    isLoading.value = false
    ;(window as any).DCLoans(partner, 'orderByToken', { token }, (result: any) => {
      console.log(result)
    })
  } catch (e) {
    errorMessage.value = 'Не удалось загрузить форму оплаты. Попробуйте обновить страницу.'
    isLoading.value = false
  }
})
</script>

<template>
  <div class="app-layout">
    <app-header />

    <div v-if="isLoading" class="widget-overlay">
      <div class="widget-loading">
        <div class="loading-spinner" />
        <p class="loading-text">Загружаем форму оплаты...</p>
      </div>
    </div>

    <div v-if="errorMessage" class="widget-error">
      <p>{{ errorMessage }}</p>
    </div>

    <ui-footer />
  </div>
</template>

<style scoped lang="scss">
.widget-overlay {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 300px;
}

.widget-loading {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
}

.loading-text {
  font-size: 18px;
  font-weight: 600;
  color: #262626;
  margin: 0;
}

.loading-spinner {
  width: 48px;
  height: 48px;
  border: 4px solid #e0e0e0;
  border-top-color: #72a6ff;
  border-radius: 50%;
  animation: spin 0.8s linear infinite;
}

.widget-error {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 300px;
  padding: 24px;
  text-align: center;
  color: #d32f2f;
  font-size: 16px;
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}
</style>
